var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "DashboardCardScaffold",
    {
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "flex items-center" },
                [
                  _c("ManagerContractorDBIcon", {
                    staticClass: "h-8 w-8 fill-current text-primary-500 mr-2",
                  }),
                  _c(
                    "RouterLink",
                    {
                      staticClass: "hover:text-primary-500",
                      attrs: {
                        to: {
                          name: _vm.routes.MANAGER_CONTRACTOR_DATABASE,
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "font-semibold text-base" }, [
                        _vm._v("My Contractor Database"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c("InvitationModalWithButton", {
                staticClass: "flex flex-grow justify-end",
                attrs: {
                  companyId: _vm.companyId,
                  currentUser: _vm.currentUser,
                  currentUserId: _vm.currentUserId,
                  companyBusinessName: _vm.companyBusinessName,
                  isManager: _vm.isManager,
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "CardItemScaffold",
        {
          staticClass: "mb-2",
          attrs: { itemNumber: _vm.contractorsTotal, itemTitle: "Contractors" },
          scopedSlots: _vm._u([
            {
              key: "icon",
              fn: function () {
                return [
                  _c("SimplePersonIcon", {
                    staticClass: "fill-current text-primary-500 h-5 w-5",
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("ItemChipsWithMore", {
            attrs: {
              items: _vm.contractorsInfo,
              moreNumber: _vm.contractorsTotal,
              routeName: _vm.routes.CONTRACTOR_DETAILS_ABOUT,
              showNotAvailable: false,
              navigateTo: { name: _vm.routes.MANAGER_CONTRACTOR_DATABASE },
              maxChipWidth: "max-w-40",
              isPerson: "",
            },
          }),
        ],
        1
      ),
      _c(
        "CardItemScaffold",
        {
          attrs: {
            itemNumber: _vm.newContractorsTotal,
            itemTitle: _vm.newContractorsText,
          },
          scopedSlots: _vm._u([
            {
              key: "icon",
              fn: function () {
                return [
                  _c("SimplePersonIcon", {
                    staticClass: "fill-current text-primary-500 h-5 w-5",
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("ItemChipsWithMore", {
            attrs: {
              items: _vm.newContractorsInfo,
              moreNumber: _vm.newContractorsTotal,
              routeName: _vm.routes.CONTRACTOR_DETAILS_ABOUT,
              showNotAvailable: false,
              navigateTo: { name: _vm.routes.COMPANY_DATABASE },
              isPerson: "",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }